var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTrustedShops = function SvgTrustedShops(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -843.15,
    cy: 401.1,
    r: 0.05,
    fx: -843.15,
    fy: 401.1,
    gradientTransform: "matrix(296.25 0 0 -296.25 249790.79 118833.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9c9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#656667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: -842.58,
    cy: 404.27,
    r: 0.07,
    fx: -842.58,
    fy: 404.27,
    gradientTransform: "scale(185.6 -185.6)rotate(-49.89 -855.86 -703.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffefc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#fffdf7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1cb54"
  })), /*#__PURE__*/React.createElement("style", null, ".ap,.ar{fill-rule:evenodd}.ap{fill:#fff}.ar{fill:#044d73}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "f",
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "M12 1c6.1 0 11.03 4.93 11.03 11.03-.58 14.63-21.47 14.63-22.06 0C.97 5.93 5.92 1 12 1m.09 4.13c-9.15.36-9.17 13.45 0 13.82a6.9 6.9 0 0 0 0-13.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "M19 12.03a6.9 6.9 0 0 1-6.9 6.9c-9.17-.36-9.15-13.45 0-13.82a6.93 6.93 0 0 1 6.9 6.92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "m19.33 9.5.71-.23c.04.28.23.62.45.75.28.19.83.02.92-.32.15-.28-.15-1.03-.26-1.26l-1.97.62.15.43ZM21 8.97c.11.21.17.54-.11.64-.26.09-.45-.19-.49-.45z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M18.41 7.73c.34.51.92.62 1.5.24 1.2-.79.06-2.48-1.14-1.65-.51.32-.69.88-.36 1.41m.62-1.01c.34-.23.69-.24.88.04.39.56-.83 1.35-1.18.79-.17-.28-.04-.6.3-.83",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m16.56 5.75.56-.7.6.51-.54.67.35.3 1.32-1.63-.36-.3-.51.64-.6-.51.51-.62-.38-.3-1.31 1.64z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M14.96 4.88c.53.23.9.06 1.03-.26.11-.28.04-.53-.24-.79-.21-.21-.28-.3-.24-.43.04-.09.17-.15.36-.08s.3.19.36.26l.24-.3c-.36-.41-1.18-.62-1.43-.04-.11.28.02.54.28.81.21.19.26.28.21.41-.15.32-.71-.08-.83-.24l-.24.32c.08.09.28.24.51.34Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "M12.81 2.41c-.28-.28-1.07-.26-1.5-.21l-.04 2.06c.43.08 1.2.08 1.52-.21.43-.34.51-1.31.02-1.65Zm-.9 1.52c-.06 0-.13 0-.17-.02l.02-1.37c.47-.08.9.11.86.66.02.51-.28.75-.71.73",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "m10.76 4.34-.11-.38-.83.23-.13-.49.75-.19-.09-.37-.75.19-.11-.42.8-.2-.11-.4-1.24.34.53 2.03z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "m7.29 3.83.81 1.5.41-.24-.8-1.48.5-.28-.19-.34-1.42.77.19.33z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M6.09 5.75c.24-.11.38-.11.47-.02.24.26-.36.62-.56.66l.19.36c.13-.04.36-.15.53-.3.43-.39.43-.79.19-1.05-.21-.21-.45-.24-.83-.09-.28.11-.39.15-.49.04-.21-.23.32-.54.47-.58l-.19-.36c-.53.15-1.05.83-.62 1.28.21.23.51.21.84.08Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M5.45 7.94c.28-.47.21-.9-.34-1.26l-.99-.62-.24.39 1.01.64c.32.21.39.41.26.62s-.36.23-.68.04l-1.01-.64-.24.39.99.62c.54.38.96.26 1.24-.19Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "m4.5 10.12-.79-.23.04-.13c.06-.19.15-.24.41-.24.26.02.43 0 .51 0l.13-.47c-.09.02-.38 0-.62 0-.21 0-.36.04-.45.17-.02-.39-.51-.68-.86-.43-.28.17-.43.92-.49 1.22l1.99.56zm-1.07-.51-.06.19-.54-.15c.02-.21.13-.56.41-.47.17.04.24.21.19.43",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "m4.27 11.58-1.7-.04.01-.58h-.39l-.04 1.61h.4l.02-.56 1.68.04z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "m4.72 17.37.21.36-.51.32c-.45-.36-.54-1.01.06-1.37.6-.39 1.2.08 1.28.69l.21-.06c-.15-.79-.94-1.33-1.67-.86-.84.53-.51 1.43.11 1.89l.83-.51-.36-.56-.15.09Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v",
    d: "m7.33 18.44-.77.92c-.28.34-.56.38-.79.19-.21-.17-.24-.45.06-.79l.77-.92-.21-.17-.77.9c-.41.49-.32.86 0 1.14.34.28.75.3 1.14-.19l.77-.9-.21-.19Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "m6.94 20.64.24.11.45-.51.66.3-.08.68.24.11.21-2.14-.28-.13zm1.52-1.28c-.06.23-.09.75-.11.99l-.56-.24c.17-.21.53-.56.68-.75Z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "x",
    d: "M10.26 19.68a2.5 2.5 0 0 0-.51-.06l-.39 1.97.26.06.17-.86.24.04c.23.06.32.19.32.47 0 .26.02.43.04.51l.26.06c-.04-.08-.04-.28-.04-.58 0-.21-.08-.38-.21-.47.39-.04.64-.53.39-.84-.11-.15-.28-.24-.54-.28Zm.36.66c-.04.23-.24.34-.53.28l-.26-.06.15-.73c.28.02.73.13.64.51",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "m12.06 19.87-.68 2.04h.28l.21-.64h.71l.23.64h.28l-.71-2.03-.32-.02Zm-.15 1.2c.08-.24.24-.71.28-.96.06.23.24.71.32.96z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "z",
    d: "M14.72 19.47c.13.47.28 1.2.45 1.63-.28-.36-1.05-1.05-1.39-1.39l-.28.08.51 1.97.24-.06a33 33 0 0 0-.45-1.65c.3.38 1.07 1.05 1.43 1.41l.26-.08-.51-1.97z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    d: "m16.71 18.76-.11-.19-1.32.72.11.2.53-.3.88 1.6.23-.13-.87-1.6z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    d: "m18.28 19.51-.48-.54.58-.53-.15-.17-.58.53-.44-.47.6-.56-.13-.17-.82.75 1.39 1.5.84-.77-.15-.17z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "m19.65 17.97-.62-.39.43-.66-.18-.11-.42.66-.54-.36.45-.69-.19-.12-.58.92 1.71 1.11.6-.96-.17-.13z",
    className: "ap"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    d: "M21.88 11.6c-.02-.49-.32-.79-.68-.75-.3.02-.49.26-.6.6-.08.26-.15.36-.28.36-.36.02-.24-.68-.15-.86l-.39-.08c-.06.11-.11.36-.09.6.04.56.34.83.69.81.3-.02.47-.21.6-.56.09-.28.15-.39.28-.39.32 0 .23.6.15.73l.39.09c.04-.13.08-.3.08-.54Z",
    className: "ap"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    fill: "#f7e19e",
    fillRule: "evenodd",
    d: "M3.82 14.47c-.02.51-.75.51-.77 0 0-.51.75-.51.77 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "af",
    fill: "#f1cb53",
    fillRule: "evenodd",
    d: "M20.95 14.47c-.02.51-.75.51-.77 0 0-.51.75-.51.77 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    fill: "#006dad",
    fillRule: "evenodd",
    d: "M13.39 7.47c1.18 0 2.01.56 2.18 1.48.09.49-.02.92-.17 1.26l-.02.06-.02.04-.02.04-.06.11-.02.04-.02.04-.02.04s0 .02-.02.02l-.02.04-.02.04-.02.04s0 .02-.02.02l-.02.04-.04.04-.02.02-.04.04-.02.04c-.45.49-1.14.92-2.16 1.31l-.11.04c-.68.24-1.35.43-2.04.58l-.21.06-.21.06-.32.08c-.08 1.63.36 2.48 1.28 2.59l.24.02c.53 0 .96-.21 1.31-.45l.06-.04v-.08l.06-.04.06-.04.08-.06c.47-.36.83-.79 1.13-1.22l.11-.15.51.43-.04.04-.08.09c-.04.06-.08.09-.09.15l-.08.09c-.43.6-.86 1.09-1.46 1.46l-.06.04-.02.02-.06.04s-.09.06-.15.08l-.06.04-.06.04a4.3 4.3 0 0 1-1.89.49c-.19 0-.36-.02-.54-.04-1.37-.21-2.16-1.2-2.18-2.81v-.06a6.4 6.4 0 0 1 1.37-4.05l.04-.06a4.87 4.87 0 0 1 3.79-2.06h.17Zm-.49.71c-.06 0-.13 0-.19.02h-.04c-.64.11-1.11.53-1.48 1.03l-.04.06-.02.04-.04.06-.04.06-.04.06-.04.06-.04.06-.04.06-.04.06c-.43.69-.71 1.5-.86 2.46a6.9 6.9 0 0 0 2.49-.94c.94-.62 1.41-1.35 1.37-2.18-.08-.51-.45-.88-.98-.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    d: "M8.27 13.75a6.53 6.53 0 0 1 1.39-4.14 5 5 0 0 1 3.86-2.03h.17c.32 0 .6.04.86.11a2.9 2.9 0 0 0-1.18-.24h-.17a4.96 4.96 0 0 0-3.79 2.06A6.37 6.37 0 0 0 8 13.62c.02 1.46.64 2.42 1.74 2.76-.9-.39-1.46-1.31-1.48-2.63Z",
    className: "ar"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    d: "M11.72 15.69c.68 0 1.11-.38 1.5-.68.49-.38.92-.84 1.24-1.28l-.21-.17-.04.06c-.32.45-.71.92-1.22 1.31-.39.3-.92.64-1.59.64-.08 0-.17 0-.24-.02a.3.3 0 0 1-.15-.04c.15.08.3.13.47.15l.24.02Z",
    className: "ar"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    d: "M13.84 9.1c.04.83-.41 1.54-1.37 2.18-.6.39-1.33.69-2.14.86l-.02.09a6.6 6.6 0 0 0 2.49-.84c.94-.62 1.41-1.35 1.37-2.18-.02-.49-.32-.83-.75-.9.23.17.39.43.41.79Z",
    className: "ar"
  })))))));
};
export { SvgTrustedShops as ReactComponent };
export default __webpack_public_path__ + "static/media/trustedShops.8f6b6e9dc8ccd3b47f10f25292021021.svg";